import React from 'react'

import Image from 'next/image'

import { PaddingProps } from 'styled-system'

import { SectionWrapper } from 'Components/Blocks'
import { Column, Row, Text } from 'Components/UI'

import { BLUEPRINT } from 'Constants/Paths'

import { WE_HAVE_PERFECT_REPUTATION_LOGOS } from './constants'
import { Container, ImageHolder, StyledLink } from './styles'

type Props = PaddingProps

function WeHavePerfectReputationSection({ ...rest }: Props) {
  return (
    <SectionWrapper asCard {...rest}>
      <Container
        flexDirection={[
          'column',
          'column',
          'column',
          'column',
          'column',
          'row',
        ]}
      >
        <Text as="h2" medium title title40>
          Yes, we have
          <br />
          perfect reputation
        </Text>

        <Column gap={[17, 17, 17, 17, 17, 11]} maxWidth="770px">
          <Text as="div" body body16 semiLight>
            Great products start with top engineers and a proven system. Our
            Boilerplate lets us build faster, automate infrastructure, and
            deliver testable results from day one.
            <br />
            <br />
            We have compounded and packaged our experience in a form of a
            reusable system we call{' '}
            <StyledLink href={BLUEPRINT}>
              <Text as="span" body16 medium>
                StartupCraft Boilerplate
              </Text>
            </StyledLink>
            . It allowed us to allocate maximum time to important solutions of
            your business, reuse trivial features like Authentication and fully
            automate infrastructure management. You will be able to try the very
            beginning version of your application from day 1.
          </Text>

          <Row
            gap={13}
            justifyContent={['center', 'center', 'center', 'flex-start']}
            wrap
          >
            {WE_HAVE_PERFECT_REPUTATION_LOGOS.map(item => (
              <ImageHolder key={item.id} width={item.image.width / 2}>
                <Image
                  alt={item.name}
                  height={item.image.height}
                  key={item.id}
                  src={item.image.src}
                  width={item.image.width}
                />
              </ImageHolder>
            ))}
          </Row>
        </Column>
      </Container>
    </SectionWrapper>
  )
}

export default WeHavePerfectReputationSection
